import { createApiRef } from '@backstage/core-plugin-api';



export const gluesApiRef = createApiRef({
  id: 'plugin.glues.api'
});

export const agentApiRef = createApiRef({
  id: 'plugin.glues.agent.api'
});

export const bitbucketWorkspaceURL = 'https://bitbucket/accelbyte'















































































































export var GlueType; (function (GlueType) {
  const awsparamstore = 'awsparamstore'; GlueType["awsparamstore"] = awsparamstore;
})(GlueType || (GlueType = {}));